import { useRecordContext } from "react-admin";

export const UserTitle = ({record}) => {
  if (record)
    return <span>User: {record.name}</span>;
  else
    return null;
};
